import { z as zod } from 'zod'

import { DefaultSchemas } from './defaultSchemas'

export const LookupVouchersSchemas = zod.object({
    voucherId: zod.number().optional().nullable(),
    voucherCode: zod.string().optional().nullable(),
    voucherName: zod.string().optional().nullable(),
    voucherTypeId: zod.number().optional().nullable(),
    productSkus: zod.string().optional().nullable(),
    startDate: zod.string().optional().nullable(),
    pSize: zod.number().optional().nullable(),
    pNumber: zod.number().optional().nullable(),
})

export type ListVouchersDataTypes = zod.infer<
    typeof LookupVouchersSchemas
>

export const VoucherParamsSchemas = zod.object({
})

export const CampaignsDefaultSchemas = DefaultSchemas

export const CampaignsDataSchemas = zod.object({
    campaignName: zod.string(),
    campaignId: zod.number(),
    campaignDescription: zod.string().nullable(),
})

export const CampaignsAPISchemas =
    CampaignsDefaultSchemas.merge(
        zod.object({
            data: zod.array(CampaignsDataSchemas),
        })
    )

export type CampaignsAPITypes = zod.infer<
    typeof CampaignsAPISchemas
>
export type CampaignsDataTypes = zod.infer<
    typeof CampaignsDataSchemas
>

export const CampaignCreateFormSchemas = zod.object({
    campaignName: zod.string().min(1, { message: 'This field is required.' }),
    campaignCode: zod.string().min(1, { message: 'This field is required.' }),
    externalReference: zod.string().min(1, { message: 'This field is required.' }),
    startDate: zod.string().optional().nullable(),
    endDate: zod.string().optional().nullable(),
    description: zod.string().optional(),
    statusId: zod.number({
        required_error: 'This field is required.',
        invalid_type_error: 'This field is required.',
    }),
    programUserId: zod.number({
        required_error: 'This field is required.',
        invalid_type_error: 'This field is required.',
    }),
    flCommit: zod.number().optional().nullable(),
})

export interface CampaignCreationTypes {
    outcomeCode: string
    outcomeMessage: string
    outcomeUserMessage: string
    data: {
        campaignId: number
    }
}

export const VouchersDefaultSchemas = DefaultSchemas

export const VouchersDataSchemas = zod.object({
    voucherId: zod.number(),
    voucherCode: zod.string(),
    voucherTypeId: zod.number(),
    voucherTypeDescription: zod.string().optional().nullable(),
    mcaId: zod.number().nullable(),
    mcaName: zod.string().optional(),
    voucherIssuerId: zod.number(),
    voucherIssuerName: zod.string().optional(),
    voucherName: zod.string(),
    description: zod.string().optional(),
    imageUrl: zod.string().optional(),
    voucherValue: zod.number(),
    securityCode: zod.number().optional().nullable(),
    startDate: zod.string().optional(),
    endDate: zod.string().optional(),
    offerTypeId: zod.number().optional(),
    offerValue2: zod.number().optional(),
    offerValue3: zod.number().optional(),
    merchants: zod.string().array().optional().nullable(),
    pluCode: zod.string().optional(),
    productSkus: zod.string().array().optional().nullable(),
})

export const VoucherListTableSchemas = zod.object({
    tableData: VouchersDataSchemas.array()
})

export const VouchersAPISchemas =
    VouchersDefaultSchemas.merge(
        zod.object({
            data: zod.array(VouchersDataSchemas),
        })
    )

export type VouchersAPITypes = zod.infer<
    typeof VouchersAPISchemas
>
export type VouchersDataTypes = zod.infer<
    typeof VouchersDataSchemas
>

export const VoucherCreateFormSchemas = zod.object({
    voucherTypeId: zod.number().min(1, { message: 'This field is required.' }),
    voucherIssuerId: zod.number().min(1, { message: 'This field is required.' }),
    voucherValue: zod.number({
        required_error: 'This field is required.',
        invalid_type_error: 'This field is required.',
    }),
    pluCode: zod.string().optional().nullable(),
    voucherName: zod.string().optional(),
    startDate: zod.string().optional().nullable(),
    endDate: zod.string().optional().nullable(),
    references: zod.string().array().optional(),
    voucherCount: zod.number().optional().nullable(),
    merchants: zod.string().array().optional().nullable(),
    flSecurityCode: zod.number().optional().nullable(),
    description: zod.string().optional(),
    imageUrl: zod.string().optional(),
    mcaId: zod.number().optional().nullable(),
    offerValue2: zod.number().optional(),
    offerValue3: zod.number().optional(),
    offerTypeId: zod.number().optional(),
    productSkus: zod.string().array().optional().nullable(),
    merchantTypeId: zod.number().optional().nullable(), //not passing this to API
})

export const GoodwillVoucherCreateFormSchemas = zod.object({
    voucherTypeId: zod.number().min(1, { message: 'This field is required.' }),
    voucherIssuerId: zod.number().min(1, { message: 'This field is required.' }),
    voucherIssuerName: zod.string().optional(),
    voucherValue: zod.number({
        required_error: 'This field is required.',
        invalid_type_error: 'This field is required.',
    }),
    pluCode: zod.string().optional().nullable(),
    voucherName: zod.string().optional(),
    startDate: zod.string().optional().nullable(),
    endDate: zod.string().optional().nullable(),
    references: zod.string().array().optional(),
    voucherCount: zod.number().optional().nullable(),
    merchants: zod.string().array().optional().nullable(),
    flSecurityCode: zod.number().optional().nullable(),
    description: zod.string().optional(),
    imageUrl: zod.string().optional(),
    mcaId: zod.number().optional().nullable(),
    mcaName: zod.string().optional().nullable(),
    offerValue2: zod.number().optional(),
    offerValue3: zod.number().optional(),
    offerTypeId: zod.number().optional().nullable(),
    productSkus: zod.string().array().optional().nullable(),
    merchantTypeId: zod.number().optional().nullable(), //not passing this to API
})

export interface VoucherCreationTypes {
    outcomeCode: string
    outcomeMessage: string
    outcomeUserMessage: string
    data: {
        voucherId: number
        voucherCode: string
    }
}

export const VoucherViewFormSchemas = zod.object({
    voucherId: zod.number(),
    voucherCode: zod.string(),
    voucherTypeId: zod.number(),
    voucherIssuer: zod.string(),
    voucherValue: zod.number(),
    pluCode: zod.string().optional().nullable(),
    voucherName: zod.string().optional(),
    startDate: zod.string().optional().nullable(),
    endDate: zod.string().optional().nullable(),
    references: zod.string().array().optional(),
    voucherCount: zod.number().optional().nullable(),
    merchants: zod.string().array().optional().nullable(),
    flSecurityCode: zod.number().optional().nullable(),
    description: zod.string().optional(),
    imageUrl: zod.string().optional(),
    mca: zod.string().optional().nullable(),
    offerValue2: zod.number().optional(),
    offerValue3: zod.number().optional(),
    offerTypeId: zod.number().optional(),
    productSkus: zod.string().array().optional().nullable(),
    merchantTypeId: zod.number().optional().nullable(),
})

export const VoucherUpdateFormSchemas = zod.object({
    voucherId: zod.number(),
    voucherCode: zod.string(),
    voucherTypeId: zod.number(),
    voucherValue: zod.number().optional().nullable(),
    voucherName: zod.string().optional().nullable(),
    startDate: zod.string().optional().nullable(),
    endDate: zod.string().optional().nullable(),
    description: zod.string().optional().nullable(),
    imageUrl: zod.string().optional().nullable(),
    offerValue2: zod.number().optional().nullable(),
    offerValue3: zod.number().optional().nullable(),
    offerTypeId: zod.number().optional().nullable(),
    pluCode: zod.string().optional().nullable(),
    merchants: zod.string().array().optional().nullable(),
    productSkus: zod.string().array().optional().nullable(),
    merchantTypeId: zod.number().optional().nullable(), //not passing this to API
})

export interface VoucherUpdateTypes {
    outcomeCode: string
    outcomeMessage: string
    outcomeUserMessage: string
}

export const VoucherAPISchemas = DefaultSchemas.merge(zod.object({
    data: VouchersDataSchemas.array()
}));

export type CampaignCreateFormTypes = zod.infer<typeof CampaignCreateFormSchemas>;
export type VoucherCreateFormTypes = zod.infer<typeof VoucherCreateFormSchemas>;
export type GoodwillVoucherCreateFormTypes = zod.infer<typeof GoodwillVoucherCreateFormSchemas>;
export type VoucherViewFormTypes = zod.infer<typeof VoucherViewFormSchemas>;
export type VoucherUpdateFormTypes = zod.infer<typeof VoucherUpdateFormSchemas>;
export type VoucherListTableTypes = zod.infer<typeof VoucherListTableSchemas>;
export type VoucherParamsTypes = zod.infer<typeof VoucherParamsSchemas>;
export type VoucherDataTypes = zod.infer<typeof LookupVouchersSchemas>;
export type VoucherAPITypes = zod.infer<typeof VoucherAPISchemas>;